import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { AccountRoute } from '../../routing'

export class AccountPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <AccountRoute />
            </Fragment>
        )
    }
}
